import { createFileRoute } from '@tanstack/react-router';
import { CommentAutomationEditorPage } from '@/features/marketing';

/** `comment-dm_` keeps the editor out of the list route's nesting; it renders as its own page. */
export const Route = createFileRoute('/_auth/$orgId/marketing/comment-dm_/new')({
  component: NewCommentAutomationRoute,
});

function NewCommentAutomationRoute() {
  const { orgId } = Route.useParams();
  return <CommentAutomationEditorPage orgId={orgId} />;
}
